import {
  Box,
  ButtonCore,
  Typography,
} from "@braintrust/braintrust-ui-components";

import styles from "./style.module.scss";

type CreateJobMenuItemProps = {
  icon: string;
  id: "custom-job" | "upload-job";
  onClick: () => void;
  subText?: string;
  title: string;
};

const CreateJobMenuItem = ({
  icon,
  id,
  onClick,
  subText,
  title,
}: CreateJobMenuItemProps) => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "185px" },
        padding: { xs: "24px 32px", sm: "32px" },
      }}
      className={styles.createJobItem}
      component={ButtonCore}
      onClick={onClick}
    >
      <Box className={`${styles.jobItemIcon} ${styles[id]}`}>
        <img src={icon} alt="job type" height={24} width={24} />
      </Box>
      <Typography
        variant="label"
        size="medium"
        component="span"
        fontWeight={500}
        sx={{ textAlign: "left" }}
      >
        {title}
      </Typography>
      <Typography
        variant="label"
        size="small"
        component="span"
        fontWeight={400}
        sx={{ textAlign: "left", color: "#767676" }}
      >
        {subText}
      </Typography>
    </Box>
  );
};

type CreateJobMenuProps = {
  createJobOptions: (CreateJobMenuItemProps & { disabled: boolean })[];
};

export const CreateJobMenu = ({ createJobOptions }: CreateJobMenuProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 4,
          marginTop: 5,
          justifyContent: "center",
        }}
      >
        {createJobOptions
          .filter((e) => !e.disabled)
          .map((option) => (
            <CreateJobMenuItem key={option.id} {...option} />
          ))}
      </Box>
    </>
  );
};
